<pm-widget-base-wrapper [isLoading]="isLoading" [name]="name">
  <ng-template
    pmWidgetTitle
    infoTooltipText="{{
      'RESULT.INSIGHTS.WIDGETS.PORTFOLIO_TOTALS.TOOLTIP' | translate
    }}"
  >
    {{ 'RESULT.INSIGHTS.WIDGETS.PORTFOLIO_TOTALS.TITLE' | translate }}
  </ng-template>

  <ng-template pmWidgetHeader>
    <pm-form-field label="RESULT.INSIGHTS.GENERAL.SELECT_FILTER">
      <pm-form-input-select
        [ngModel]="currentGroupName"
        [allowUnselect]="false"
        (ngModelChange)="onGroupChange($event)"
        [data]="groupsSelectOptions()"
      />
    </pm-form-field>

    <pm-form-field label="RESULT.INSIGHTS.GENERAL.SELECT_YEARS">
      <pm-form-input-select
        [allowSearching]="true"
        [allowUnselect]="false"
        [ngModel]="currentYear"
        (ngModelChange)="onYearChange($event)"
        [data]="yearsSelectOptions()"
      />
    </pm-form-field>
  </ng-template>

  <ng-template pmWidgetContent>
    @if (this.isError) {
      <div class="flex justify-center items-center h-full text-center p-4">
        <pm-h3>
          {{ 'RESULT.INSIGHTS.GENERAL.TECHNICAL_ERROR' | translate }}
        </pm-h3>
      </div>
    } @else {
      <highcharts-chart
        id="portfolio-totals-chart"
        [(update)]="chartUpdated"
        (chartInstance)="setChartInstance($event)"
        [oneToOne]="true"
        [options]="this.chartOptions"
        class="!h-full !w-full block"
      >
      </highcharts-chart>
    }
  </ng-template>
  <ng-template pmWidgetActions>
    @if (isDialogInstance) {
      <pm-button
        variant="subdued"
        [pmTooltip]="'RESULT.INSIGHTS.BUTTONS.EXIT_FULL_SCREEN_TOOLTIP'"
        (handleClick)="exitFullScreen()"
        [icon]="scanIcon"
      />
    } @else {
      <pm-button
        variant="subdued"
        [pmTooltip]="'RESULT.INSIGHTS.BUTTONS.FULL_SCREEN_TOOLTIP'"
        [icon]="scanIcon"
        (handleClick)="
          showFullScreen(PortfolioTotalsWidgetComponent, {
            targetUnit: this.targetUnit,
            filter: this.currentGroupName,
            year: this.currentYear.toString(),
          })
        "
      />
    }
  </ng-template>
</pm-widget-base-wrapper>
